import { render } from "./BadgeNew.vue?vue&type=template&id=2b90e184&scoped=true"
import script from "./BadgeNew.vue?vue&type=script&lang=js"
export * from "./BadgeNew.vue?vue&type=script&lang=js"

import "./BadgeNew.vue?vue&type=style&index=0&id=2b90e184&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b90e184"]])

export default __exports__